import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, effect } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { AppConfig } from 'client/app/app.config';
import { ApiClientConstant } from '@cureskin/api-client';
import { getRegimenProductsCount } from 'client/helper/regimen-helper';
import { Router } from '@angular/router';
import { RegimenService } from '@services/regimen-service/regimen.service'
import { EventLoggerService } from '@services/event-logger-service';

const SELECTED_VARIANT_OUTLINE_CLASSES = 'tw-outline tw-outline-[1.5px] tw-shadow-z4';
@Component({
  selector: 'choose-plan-rebranded',
  imports: [CommonModule, CsIconModule],
  templateUrl: './choose-plan-rebranded.component.html',
})
export class ChoosePlanRebrandedComponent implements OnChanges {
  readonly selectedVariantOutlineClasses = SELECTED_VARIANT_OUTLINE_CLASSES;
  @Input() regimen: any;
  @Output() onVariantChange: EventEmitter<string> = new EventEmitter();
  @Input() user: Table.User;

  coreVariant: any;
  advancedVariant: any;
  coreVariantImage: string = '';
  advancedVariantImage: string = '';
  productsCount: number = 0;
  constructor(
    readonly appConfig: AppConfig,
    private readonly router: Router,
    private readonly regimenService: RegimenService,
    private readonly eventLoggerService: EventLoggerService,
  ) {
    effect(() => {
      if (this.regimenService.variantImagesReady()) {
        this.getVariantImages();
      }
    });
  }


  ngOnChanges(): void {
    this.initializeComponent();
  }

  private initializeComponent(): void {
    this.getVariantImages();
    this.getVariants();
  }

  getVariantImages(): void {
    const regimenVariantImages = this.regimenService.getRegimenVariantImages(this.regimen.class);
    this.coreVariantImage = regimenVariantImages?.variant_1499;
    this.advancedVariantImage = regimenVariantImages?.variant_1999;
  }

  getVariants(): void {
    this.coreVariant = this.regimen?.variants?.filter((variant: any): boolean => variant.variantId === this.appConfig.Shared.Regimen.VariantId.variant_1499)?.[0];
    this.advancedVariant = this.regimen?.variants?.filter((variant: any): boolean => variant.variantId === this.appConfig.Shared.Regimen.VariantId.variant_1999)?.[0];
  }

  get pagePalette() {
    const variantId = this.regimen?.selectedVariantId || this.regimen?.variantId || ApiClientConstant.Regimen.SelectedVariantId.variant_1499;
    return this.regimenService.getRegimenPaletteForVariant(variantId);
  }

  get corePalette() {
    return this.regimenService.getRegimenPaletteForVariant(ApiClientConstant.Regimen.SelectedVariantId.variant_1499);
  }

  get advancedPalette() {
    return this.regimenService.getRegimenPaletteForVariant(ApiClientConstant.Regimen.SelectedVariantId.variant_1999);
  }

  emitChangeRegimenKitInfo(plan: string): void {
    if (this.regimen?.orderPlaced) return;
    this.onVariantChange.emit(plan);
  }

  get getProductsCount(): number {
    return getRegimenProductsCount(this.regimen);
  }

  viewProducts(): void {
    this.router.navigate(['/user/regimen/products'],
      { queryParams: { class: this.regimen.class, username: this.user.get('username'), regimenId: this.regimen.regimenId } });
  }

  get is1499VariantSelected(): boolean {
    return this.regimen?.variantId === this.appConfig.Shared.Regimen.VariantId.variant_1499 || !this.regimen?.variantId;
  }

  get is1999VariantSelected(): boolean {
    return this.regimen?.variantId === this.appConfig.Shared.Regimen.VariantId.variant_1999;
  }
}
